// removed by extract-text-webpack-plugin
module.exports = {"PostWrapper":"MjJaa9HJjpC_vwfPGzMPP","Summary":"_32lsUxF1dFKqKA_KMmeL82","StatsText":"_3OP0YmXjndTV8CnChHVwm9"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/RightPanel/ClientChatMenu/HelpDesk/RightPanel/PostHistory/style.css
// module id = 2464
// module chunks = 0